import React, { useEffect, useState } from "react";
import { Row, Col, Descriptions, Divider } from "antd";
import { FormattedMessage } from "react-intl";

import UserListTable from "../../../userList/userListTable";
import { parseDateTime } from "../../../../modules/consignmentFunctions";

const ClientUsers = ({ data }) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    setUsers(
      data && data.users
        ? data.users.map((u, i) => ({
            ...u,
            key: i,
            lastLogin: parseDateTime(u.lastLogin),
          }))
        : []
    );
  }, [data]);

  return (
    <>
      <Divider />
      <Row gutter={[0, 40]}>
        <Col>
          <Descriptions column={4} layout="vertical" bordered>
            <Descriptions.Item
              label={
                <FormattedMessage
                  id="clientUser.client.name"
                  defaultMessage="Název"
                />
              }
            >
              {data.name}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <FormattedMessage
                  id="clientUser.client.companyId"
                  defaultMessage="IČO"
                />
              }
            >
              {data.companyId}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <FormattedMessage
                  id="clientUser.client.account"
                  defaultMessage="z-account"
                />
              }
            >
              {data.code}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <FormattedMessage
                  id="clientUser.client.evoCode"
                  defaultMessage="EVO kód"
                />
              }
            >
              {data.evoCode}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={[0, 40]}>
        <Col>
          <UserListTable short admin={false} users={users} />
        </Col>
      </Row>
    </>
  );
};

export default ClientUsers;
